import React from 'react';
import cx from 'classnames';
import styles from './styles';

export default function Icon({ onClick }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 18 18"
      width="18"
      height="18"
      className={cx(styles.icon, styles.svg)}
      onClick={onClick}
    >
      <defs>
        <path id="a" d="M.0007 0H18v18H.0007z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="b" fill="#fff">
          <use xlinkHref="#a" />
        </mask>
        <path
          fill="#ae72b7"
          d="M9.6587 10.8h-1.53c0-2.027 2.342-2.552 2.342-4.055 0-.8-.573-1.2-1.424-1.2-.838 0-1.463.455-1.73 1.269l-1.316-.773C6.5057 4.69 7.7287 4 9.0867 4c1.476 0 2.914.91 2.914 2.648 0 2.097-2.342 2.662-2.342 4.152m-.759 3.2c-.558 0-.997-.469-.997-1.034 0-.58.439-1.035.997-1.035.546 0 .998.455.998 1.035 0 .565-.452 1.034-.998 1.034m.101-14c-4.971 0-9 4.029-9 9 0 4.97 4.029 9 9 9 4.97 0 9-4.03 9-9 0-4.971-4.03-9-9-9"
          mask="url(#b)"
        />
      </g>
    </svg>
  );
}
